var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13358_33835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3295 3.65358L15.2459 5.73719L12.76 5.24001L12.2628 2.75408L14.3464 0.670472C12.9396 0.295706 11.3776 0.656163 10.2741 1.75972C8.98655 3.04725 8.70526 4.95996 9.43015 6.52075L1.18766 13.9782C0.336737 14.7481 0.30362 16.0735 1.11506 16.885C1.9265 17.6964 3.25193 17.6633 4.02182 16.8123L11.4793 8.56987C13.04 9.29479 14.9528 9.01347 16.2403 7.72591C17.3438 6.62239 17.7043 5.0604 17.3295 3.65358Z",
    stroke: "#2b8dc8",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98031 15.7664C2.77436 15.9724 2.44048 15.9724 2.23454 15.7664C2.02859 15.5605 2.02859 15.2266 2.23454 15.0207C2.44048 14.8147 2.77436 14.8147 2.98031 15.0207C3.18625 15.2266 3.18625 15.5605 2.98031 15.7664Z",
    fill: "#2b8dc8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13358_33835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.97b5675319e31d13d6751e15d08c4f22.svg";
export { ForwardRef as ReactComponent };